import { Error, Form, Input, TextArea, ValidationStates } from '@opengov/component-library/dist';
import React from 'react';
import styles from './ReportFormInputs.scss';
import { ILocalized } from '../../../../src/locale/types';
import { REPORT_DESCRIPTION_MAX_LENGTH, REPORT_TITLE_MAX_LENGTH } from './types';

export interface IReportFormInputsProps extends ILocalized {
  disabled?: boolean;
  reportDescription: string;
  reportTitle: string;
  reportTitleValidationState: ValidationStates;
  onReportDescriptionBlur(reportDescription: string): void;
  onReportDescriptionChange(reportDescription: string): void;
  onReportTitleBlur(reportTitle: string): void;
  onReportTitleChange(reportTitle: string): void;
}

const ReportFormInputs: React.FC<IReportFormInputsProps> = (props) => {
  const { disabled, reportLocaleText } = props;

  const title = props.reportTitle ? props.reportTitle : '';
  const description = props.reportDescription ? props.reportDescription : '';

  return (
    <div className={styles.container}>
      <Form.Item
        required={true}
        label={reportLocaleText.create.titleAndDescriptionStepTitleInputLabel}
        htmlFor="reportTitle"
        className={styles.inputTitle}
      >
        <Form.CharacterCounter maxCount={REPORT_TITLE_MAX_LENGTH} currentCount={title.length} />
        <Input.Text
          dataTest="reportTitleInput"
          disabled={disabled}
          id="reportTitle"
          maxLength={REPORT_TITLE_MAX_LENGTH}
          onBlur={(value: string) => {
            props.onReportTitleBlur(value);
          }}
          onChange={(value: string) => {
            props.onReportTitleChange(value);
          }}
          validationState={props.reportTitleValidationState}
          value={title}
        />
        {props.reportTitleValidationState === ValidationStates.Error && (
          <Error dataTest="reportTitleInputError">
            {reportLocaleText.create.titleAndDescriptionStepTitleInputError}
          </Error>
        )}
      </Form.Item>

      <Form.Item
        label={reportLocaleText.create.titleAndDescriptionStepDescriptionInputLabel}
        htmlFor="reportDescription"
      >
        <Form.CharacterCounter maxCount={REPORT_DESCRIPTION_MAX_LENGTH} currentCount={description.length} />

        <TextArea
          id="reportDescription"
          dataTest="reportDescriptionInput"
          disabled={disabled}
          maxLength={REPORT_DESCRIPTION_MAX_LENGTH}
          onBlur={(value: string) => {
            props.onReportDescriptionBlur(value);
          }}
          onChange={(value: string) => {
            props.onReportDescriptionChange(value);
          }}
          rowCount={4}
          value={props.reportDescription}
        />
      </Form.Item>
    </div>
  );
};

export default ReportFormInputs;
